import { configureStore } from '@reduxjs/toolkit';

import articleReducer from './reducers/article/articule-reducer';
import authReducer from './reducers/auth-reducer';
import bannerReducer from './reducers/banner-reducer';
import bd100Reducer from './reducers/bd-100/bd-100-reducer';
import behavioralReducer from './reducers/behavioral-reducer';
import bestOfReducer from './reducers/best-of/best-of-reducer';
import commentsReducer from './reducers/comments/comments-reducer';
import detailPageReducer from './reducers/detail-page/detail-page-reducer';
import globalReducer from './reducers/global/global-reducer';
import highlightReducer from './reducers/highlight-reducer';
import historyReducer from './reducers/history/history-reducer';
import mapReducer from './reducers/map/map-reducers';
import navbarReducer from './reducers/navbar-reducer';
import nlpReducer from './reducers/nlp/nlp-reducer';
import onboardingReducer from './reducers/onboarding-reducer';
import peopleStepsReducer from './reducers/people-steps-reducer/people-steps-reducer';
import peopleReducer from './reducers/people/people-reducer';
import profileEditorReducer from './reducers/profile-editor/profile-editor-reducer';
import pulseReducer from './reducers/pulse/pulse-reducer';
import resourceSubmissionReducer from './reducers/resource-submission/resource-submission-reducer';
import resourceVotingReducer from './reducers/resource-voting/resource-voting-reducer';
import resourceWinnersReducer from './reducers/resource-winners/resource-winners-reducer';
import resourcesStepsReducer from './reducers/resources-steps-reducer/resources-steps-reducer';
import resourcesReducer from './reducers/resources/resources-reducer';
import resultsReducer from './reducers/results-reducer';
import teamingReducer from './reducers/teaming/teaming-reducer';
import toastReducer from './reducers/toast-reducer';
import userReducer from './reducers/user-reducer';

export default configureStore({
  reducer: {
    map: mapReducer,
    navbar: navbarReducer,
    onboarding: onboardingReducer,
    user: userReducer,
    results: resultsReducer,
    auth: authReducer,
    banner: bannerReducer,
    behavioral: behavioralReducer,
    highlight: highlightReducer,
    profileEditor: profileEditorReducer,
    toast: toastReducer,
    people: peopleReducer,
    history: historyReducer,
    detailPage: detailPageReducer,
    global: globalReducer,
    teaming: teamingReducer,
    nlp: nlpReducer,
    pulse: pulseReducer,
    resourceSubmission: resourceSubmissionReducer,
    resourceVoting: resourceVotingReducer,
    resourceWinners: resourceWinnersReducer,
    peopleSteps: peopleStepsReducer,
    comments: commentsReducer,
    resources: resourcesReducer,
    resourcesSteps: resourcesStepsReducer,
    bestOf: bestOfReducer,
    article: articleReducer,
    bd100: bd100Reducer,
  },
});
